import { getPath } from "@lib/helper"
import type { SupportedLocale as Lang } from "@site-types/site"
import { useRouterState } from "@tanstack/react-router"
import NavMenu from "./NavMenu"
import Title from "./Title"
import "./styles.css"

export function SideMenu({ locale, page }: { locale: Lang; page: string }) {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const currentUrl = new URL(pathname, "https://playbrain.com")

  return (
    <aside className="side-menu">
      <Title locale={locale} />
      <nav
        className="nav-main"
        data-id="site-nav"
      >
        <NavMenu
          locale={locale}
          page={page}
        />
        <div className="language-container">
          <div className={`language ${locale === "en" ? "selected-lang" : ""}`}>
            <p>
              <a
                href={getPath("en", currentUrl)}
                aria-label="ENG"
              >
                ENG
              </a>
            </p>
          </div>
          <div className={`language ${locale === "ja" ? "selected-lang" : ""}`}>
            <p>
              <a
                href={getPath("ja", currentUrl)}
                aria-label="日本語"
              >
                日本語
              </a>
            </p>
          </div>
        </div>
      </nav>
    </aside>
  )
}

export default SideMenu
